import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/business/market-shop/button'
import { Overlay } from '@/components/ui/overlay'
import { PopupRequiredProps } from '@/factories'

import * as S from './inactivity-modal.styled'

export type InactivityModalProps = PopupRequiredProps & {
  onInactive: VoidFunction
  onActive: VoidFunction
  inactivityDelay?: number
}

export const InactivityModal = ({
  onClose,
  onInactive,
  onActive,
  inactivityDelay = 30000,
}: InactivityModalProps) => {
  const { t } = useTranslation(['market-shop'])
  const totalSeconds = Math.round(inactivityDelay / 1000)
  const [countdown, setCountdown] = useState(totalSeconds)

  const handleStillActiveClick = () => {
    onClose()
    onActive()
  }

  useEffect(() => {
    let remaining = totalSeconds

    const tick = setInterval(() => {
      remaining -= 1
      setCountdown(remaining)

      if (remaining <= 0) {
        clearInterval(tick)
        onClose()
        onInactive()
      }
    }, 1000)

    return () => clearInterval(tick)
  }, [])

  return (
    <Overlay closeOnOverlayClick={false} closeOnEscapeKey={false} onClose={onClose}>
      {({ getFloatingProps, setFloating }) => (
        <S.ModalContent ref={setFloating} {...getFloatingProps()}>
          <S.Title>{t('market-shop:inactivityModal.title')}</S.Title>
          <S.SubTitle>{t('market-shop:inactivityModal.subtitle')}</S.SubTitle>
          <S.CountdownContainer $delay={inactivityDelay}>
            <span>{countdown}</span>
            <span>{t('market-shop:inactivityModal.countdownUnit')}</span>
          </S.CountdownContainer>
          <Button use="primary" size="large" onClick={handleStillActiveClick}>
            {t('market-shop:inactivityModal.confirmActive')}
          </Button>
        </S.ModalContent>
      )}
    </Overlay>
  )
}
